import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import { ItemsCarousel } from '../NewbuildingRecommendations';
import * as styles from './RedesignedNewbuildingRecommendations.css';

type TRedesignedNewbuildingRecommendationsProps = {
  renderItems(): React.ReactNode;
};

export const RedesignedNewbuildingRecommendations: React.FC<TRedesignedNewbuildingRecommendationsProps> = ({
  renderItems,
}) => {
  return (
    <section
      data-testid="RedesignedNewbuildingRecommendations"
      data-name="RedesignedNewbuildingRecommendations"
      className={styles['section']}
    >
      <div className={styles['header']}>
        <UIHeading2 as="h2">Популярные жилые комплексы от застройщиков</UIHeading2>
      </div>
      <div className={styles['carousel-wrapper']}>
        <ItemsCarousel
          blurArrowOnPointerClick
          scrollVisible
          styles={styles['carousel']}
          renderOutside={renderItems}
        />
      </div>
    </section>
  );
};
